import { UNIT_TYPE } from 'constants/constants';

export function getUnitId(unit) {
  return unit?.unit ?? unit?._id;
}

export function getUnitType(unit) {
  return unit?.type || unit?.mainType;
}

export function isDiscussionUnit(unit) {
  return (
    unit?.type === UNIT_TYPE.DISCUSSION ||
    unit?.mainType === UNIT_TYPE.DISCUSSION
  );
}

export function getDiscussionUnitRoute(slug, unitId, userId) {
  if (!slug || !unitId) {
    return '/';
  }
  const base = `/course/${slug}/unit/discussion?unitId=${unitId}`;
  return userId ? `${base}&userId=${userId}` : base;
}

export function getUnitRoute(slug, unit) {
  const unitId = getUnitId(unit);
  if (!slug || !unitId) {
    return '/';
  }
  if (isDiscussionUnit(unit)) {
    return getDiscussionUnitRoute(slug, unitId);
  }
  return `/course/${slug}/unit/${unitId}`;
}

export function getDiscussionCreateRoute(slug) {
  return `/course/${slug}/discussion/create`;
}

export function getDiscussionEditRoute(slug, unitId) {
  return `/course/${slug}/discussion/${unitId}/edit`;
}

export function getDiscussionSubmissionsRoute(slug, unitId) {
  return `/course/${slug}/submissions/discussion?unitId=${unitId}`;
}

export function getUnitSubmissionsRoute(slug, unit) {
  const unitId = getUnitId(unit);
  if (!slug || !unitId) {
    return '/';
  }
  if (isDiscussionUnit(unit)) {
    return getDiscussionSubmissionsRoute(slug, unitId);
  }
  const snapshot =
    unit?.config?.security?.type == 'SNAPSHOT'
      ? `?config=${unit.config.security.type}`
      : '';
  return `/course/${slug}/submissions/${unitId}${snapshot}`;
}
